<template>
  <div>
    <div class="set-container" :class="{ bigScreen: isBigScreen }">
      <div class="set-item" v-show="showFontTypeSetting">
        <span class="title">类型</span>
        <div class="content">
          <SliderSelect :options="fontTypeList" :value="activeFontType" :onSelect="changeFontType"></SliderSelect>
        </div>
      </div>
      <div class="set-item">
        <span class="title">字体</span>
        <div class="content">
          <el-select
            :style="{ height: '32px', width: '100%', '--fontFamily': fontFamilyVal }"
            v-model="fontFamilyVal"
            popper-class="font-families"
            class="font-family-select"
          >
            <el-option v-for="(item, index) in fontFamilyList" :key="index" :label="item.title" :value="item.value">
              <img :src="item.img" class="font-family-img" />
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="set-item" v-if="colorType !== '线性渐变' && showColorSet">
        <span class="title">颜色</span>
        <div class="content">
          <cx-color-picker
            class="custom-text-bg flex-box"
            :isThemeColor.sync="isThemeColorVal"
            :colorArr.sync="colorArrVal"
            :activeName.sync="activeNameColorVal"
            :showSecondTab="!!activeNameColorVal"
          >
          </cx-color-picker>
        </div>
      </div>
      <div class="set-item">
        <span class="title">字号</span>
        <div class="content font-flex-content">
          <single-input style="width: 88px" :value.sync="originFontSizeVal" inputSuffixs="px" />
          <div class="btn-wrapper">
            <span
              :class="originFontSizeVal === 0 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
              @click="originFontSizeVal--"
            ></span>
            <span :class="'num-btn icon-portal-plus'" @click="originFontSizeVal++"></span>
          </div>
        </div>
      </div>
      <div class="set-item">
        <span class="title">风格</span>
        <div class="content font-flex-content">
          <div class="font-arrangement-btn multiple">
            <el-tooltip class="item" effect="dark" content="加粗" placement="top-end" :open-delay="1000">
              <span :class="fontWeightVal == 600 ? 'select pd1' : 'pd1'" @click="changeFontWeight"
                ><i class="icon-portal-text-bold1"></i
              ></span>
            </el-tooltip>
            <el-tooltip
              v-for="(item, index) in styleList"
              :key="'style' + index"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                :class="fontStyleVal === item.value ? 'select pd1  no-divide' : 'pd1  no-divide'"
                @click="changeFontStyle"
                ><i :class="item._class"></i
              ></span>
            </el-tooltip>
            <el-tooltip
              v-for="(item, index) in textDecorationList"
              :key="'decorateion' + index"
              :class="['item divide', disableTextDecoration ? 'disabled' : '']"
              effect="dark"
              :content="item.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                :class="[item.value === textDecorationVal ? 'select pd1' : 'pd1']"
                @click="changeDecoration(item.value)"
                ><i :class="item._class"></i
              ></span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="set-item" v-show="showTextAlignSetting">
        <span class="title">对齐</span>
        <div class="content">
          <SliderSelect :options="arrangementList" :value.sync="textAlignVal"></SliderSelect>
        </div>
      </div>
      <div class="more-setting" v-show="showMoreBtn" @click="showMoreSetting = !showMoreSetting">
        <i class="icon-portal-right-one" v-show="showMoreSetting == false"></i>
        <i class="icon-portal-down-one" v-show="showMoreSetting == true"></i>
        更多设置
      </div>
      <template v-if="showMoreSetting == true || !showMoreBtn">
        <div class="set-item">
          <span class="title">字重</span>
          <div class="content">
            <el-select v-model="fontWeightVal" class="content-item">
              <el-option
                v-for="(item, index) in currentFontWeightList"
                :key="index"
                :selected="fontWeightVal == item.value"
                :value="item.value"
                :label="item.title"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="set-item" v-if="!hideHighLevelSetting">
          <span class="title">方向</span>
          <div class="content">
            <SliderSelect :options="writingModeList" :value.sync="writingModeVal"></SliderSelect>
          </div>
        </div>
        <div class="set-item" v-if="enableVerticalAlign && writingModeVal === 'horizontal-tb'">
          <span class="title">垂直对齐</span>
          <div class="content">
            <text-vertical-align-setting :verticalAlign.sync="verticalAlignVal" />
          </div>
        </div>
        <div v-if="!disabled.lineHeight" class="set-item">
          <span class="title">行高</span>
          <div class="content font-flex-content">
            <single-input
              class="input-size"
              dropdownClass="lineheight-dropdown"
              style="width: 88px"
              ref="elInput"
              :step="1"
              :placeHolderText="lineHeightTypeVal==='normal'?'自动':''"
              :value.sync="showLineHeightVal"
              :valueType.sync="lineHeightTypeVal"
              :defaultPercentValue="160"
              :defaultPxValue="originFontSizeVal"
              :showValueType="true"
              :showAuto="true"
              :disabled="lineHeightTypeVal==='normal'?true:false"
            />
            <div class="btn-wrapper">
              <span
                :class="lineHeightVal === 0 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                @click="lineHeightOperate('minus')"
              ></span>
              <span :class="'num-btn icon-portal-plus'" @click="lineHeightOperate('add')"></span>
            </div>
          </div>
        </div>
        <div class="set-item" v-show="showLetterSpacingSetting">
          <span class="title">字间距</span>
          <div class="content font-flex-content">
            <single-input
              style="width: 88px"
              :value.sync="letterSpacingVal"
              inputSuffixs="px"
              placeholder="请输入"
              :min="-100"
              :max="100"
            />
            <div class="btn-wrapper">
              <span
                :class="letterSpacingVal === -100 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                @click="letterSpacingVal--"
              ></span>
              <span :class="'num-btn icon-portal-plus'" @click="letterSpacingVal++"></span>
            </div>
          </div>
        </div>
        <div class="set-item" v-if="showTextShadowSetting">
          <span class="title">阴影</span>
          <div class="content">
            <div class="checkbox_colorPicker_container">
              <span class="icon-portal-plus theme-color right-icon" @click="addTextShadow"></span>
            </div>
          </div>
        </div>
        <div class="text-shadow-container" v-if="showTextShadowSetting && textShadowBlur && textShadowBlur.length">
          <text-shadow
            :boxShadowH.sync="textShadowH"
            :boxShadowV.sync="textShadowV"
            :boxShadowBlur.sync="textShadowBlur"
            :boxShadowColor.sync="textShadowColor"
          />
        </div>
        <div class="set-item" v-if="showOverflowSetting">
          <span class="title">字数限制</span>
          <div class="content">
            <SliderSelect :options="realOverflowList" :value.sync="overflowModeValue"></SliderSelect>
            <div v-show="contentHasLimit" class="mt8">
              <div class="verticallyCenter" v-show="contentHasLimitRadio == '字数'">
                <span class="mr2">超出</span>
                <single-input
                  class="size-inp mr2"
                  style="width: 58px; height: 32px"
                  :value.sync="textLimitWordsVal"
                  inputSuffixs="字"
                />
                <span v-if="!wordOmitTypeVal && !showHideText">省略</span>
                <span v-else-if="showHideText">隐藏</span>
                <cx-select v-else style="width: 70px" :selectOptions="omitOptions" :value.sync="wordOmitTypeVal"/>
              </div>
              <div class="verticallyCenter" v-show="contentHasLimitRadio == '行数'">
                <span class="mr8">超出</span>
                <single-input
                  class="size-inp mr8"
                  style="width: 72px; height: 32px"
                  :value.sync="textLimitLinesVal"
                  :min="1"
                  inputSuffixs="行"
                />
                <span>省略</span>
              </div>
            </div>
            <el-checkbox class="mt8" v-if="showHoverSet && contentHasLimit" v-model="textHoverShowAllContent"
              >悬停时显示全部</el-checkbox
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
import cxColorPicker from "@/modules/components/cxColorPicker.vue"
import textVerticalAlignSetting from "@/modules/components/textVerticalAlignSetting.vue"
import textShadow from "@/modules/components/textShadow.vue"
import SliderSelect from "./sliderSelect.vue"
import { withMethodsHistoryCombine, historyCombineWrap } from "utils/revork"
export default withMethodsHistoryCombine({
  mixins: [publicData],
  name: "textSettingComplexUpdate",
  components: {
    cxColorPicker,
    textVerticalAlignSetting,
    textShadow,
    SliderSelect
  },
  props: {
    inMapSet: {
      type: Boolean,
      default: false
    },
    showColorSet: {
      type: Boolean,
      default: true
    },
    showOverflowSetting: {
      type: Boolean,
      default: false
    },
    showTextShadowSetting: {
      type: Boolean,
      default: false
    },
    overflowTypes: {
      type: Array,
      default() {
        return ["字数", "行数", "无"]
      }
    },
    enableOverflowChange: {
      type: Boolean,
      default: true
    },
    wordOmitType: {
      type: String
    },
    enableVerticalAlign: Boolean,
    options: undefined,
    verticalAlign: String,
    textLimitLines: [Number, String],
    textLimitWords: Number,
    contentHasLimit: Boolean,
    contentHasLimitRadio: String,
    isThemeColor: Boolean,
    colorArr: undefined,
    activeNameColor: undefined,
    fontWeight: {
      type: [Number, String],
      required: true
    },
    fontSize: {
      type: [Number, String],
      required: true
    },
    fontFamily: {
      type: String,
      required: true
    },
    fontStyle: {
      type: String,
      required: true
    },
    textDecoration: {
      type: String,
      required: true
    },
    lineHeight: {
      type: [Number, String],
      required: true
    },
    letterSpacing: {
      type: [Number, String],
      required: true
    },
    writingMode: {
      type: String,
      required: false
    },
    showTextAlignSetting: {
      type: Boolean,
      default: true
    },
    textAlign: {
      type: String,
      required: false
    },
    lineHeightType: {
      type: String,
      required: false
    },
    letterSpacingType: {
      type: String,
      required: false
    },
    hideHighLevelSetting: {
      type: Boolean,
      default: false
    },
    shadowBlur: Array,
    shadowH: Array,
    shadowColor: Array,
    shadowV: Array,
    hoverShowAllContent: {
      type: Boolean,
      default: false
    },
    showHoverSet: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showHideText: {// 文案显示成隐藏
      type: Boolean,
      default: false
    },
    showFontTypeSetting: {// 是否显示字体类型
      type: Boolean,
      default: true
    },
    showMoreBtn: {// 是否显示更多按钮
      type: Boolean,
      default: true
    },
    showLetterSpacingSetting: {// 是否显示字间距
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tempLineHeightType: "",
      tempLineHeight: "",
      showMoreSetting: false,
      activeFontType: "",
      omitOptions: [
        {
          value: "hidden",
          label: "隐藏"
        },
        {
          value: "ellipsis",
          label: "省略"
        }
      ],
      fontTypeMap: {
        h1: {
          fontSize: 24,
          lineHeight: 140,
          fontWeight: 600,
          lineHeightType: "%"
        },
        h2: {
          fontSize: 20,
          lineHeight: 140,
          fontWeight: 600,
          lineHeightType: "%"
        },
        h3: {
          fontSize: 18,
          lineHeight: 140,
          fontWeight: 600,
          lineHeightType: "%"
        },
        h4: {
          fontSize: 16,
          lineHeight: 140,
          fontWeight: 600,
          lineHeightType: "%"
        },
        content: {
          fontSize: 14,
          lineHeight: 160,
          fontWeight: 400,
          lineHeightType: "%"
        }
      },
      styleList: [
        {
          _class: "icon-portal-text-italic1",
          isActive: false,
          label: "斜体",
          value: "italic"
        }
      ],
      textDecorationList: [
        {
          _class: "icon-portal-text-underline-2",
          isActive: false,
          label: "下划线",
          value: "underline"
        },
        {
          _class: "icon-portal-text-strike-through",
          isActive: false,
          label: "删除线",
          value: "line-through"
        }
      ],
      fontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false,
          label: "加粗"
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false,
          label: "斜体"
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false,
          label: "下划线"
        }
      ],
      fontFamilyList: Object.freeze([
        {
          title: "默认字体",
          value: "sans-serif",
          img: require(`@/assets/images/fontImages/默认字体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体",
          img: require(`@/assets/images/fontImages/钉钉进步体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正清刻本悦宋简体",
          value: "方正",
          img: require(`@/assets/images/fontImages/方正清刻本悦宋简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正正大黑简体",
          value: "方正正大黑简体",
          img: require(`@/assets/images/fontImages/方正正大黑简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体",
          img: require(`@/assets/images/fontImages/联想小新潮酷体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "庞门正道标题体",
          value: "庞门正道标题",
          img: require(`@/assets/images/fontImages/庞门正道标题体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源黑体",
          value: "SourceHanSansCN",
          img: require(`@/assets/images/fontImages/思源黑体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源宋体",
          value: "SourceHanSerifCN",
          img: require(`@/assets/images/fontImages/思源宋体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "优设标题黑",
          value: "YouSheBiaoTiHei",
          img: require(`@/assets/images/fontImages/优设标题黑${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "Alata",
          value: "Alata",
          img: require(`@/assets/images/fontImages/Alata${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "D-din",
          value: "D-din",
          img: require(`@/assets/images/fontImages/D-din${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Condensed",
          value: "D-din Condensed",
          img: require(`@/assets/images/fontImages/D-DIN-Condensed${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Exp",
          value: "D-din Exp",
          img: require(`@/assets/images/fontImages/D-DIN-Exp${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "Raleway",
          value: "Raleway",
          img: require(`@/assets/images/fontImages/Raleway${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular",
          img: require(`@/assets/images/fontImages/Roboto-Regular${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black",
          img: require(`@/assets/images/fontImages/Roboto-Black${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        }
      ]),
      writingModeList: [
        {
          label: "横排文字",
          value: "horizontal-tb",
          _class: "icon-portal-horizontal-text",
          icon: "icon-portal-horizontal-text",
          isActive: true
        },
        {
          label: "竖排文字",
          value: "vertical-lr",
          _class: "icon-portal-text-down1",
          icon: "icon-portal-text-down1",
          isActive: false
        }
      ],
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 600
        },
        {
          title: "加粗体",
          value: 900
        }
      ],
      overflowList: [
        {
          label: "行数",
          value: "行数",
          isActive: false
        },
        {
          label: "字数",
          value: "字数",
          isActive: false
        },
        {
          label: "无",
          value: "无",
          isActive: false
        }
      ],
      translate: 0,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      fontTypeList: [
        {
          label: "一级标题",
          value: "h1",
          _class: "icon-portal-h1",
          icon: "icon-portal-h1"
        },
        {
          label: "二级标题",
          value: "h2",
          _class: "icon-portal-h2",
          icon: "icon-portal-h2"
        },
        {
          label: "三级标题",
          value: "h3",
          _class: "icon-portal-h3",
          icon: "icon-portal-h3"
        },
        {
          label: "四级标题",
          value: "h4",
          _class: "icon-portal-h4",
          icon: "icon-portal-h4"
        },
        {
          label: "正文",
          value: "content",
          _class: "icon-portal-plain-text",
          icon: "icon-portal-plain-text"
        }
      ],
      sliderWidth: 0
    }
  },
  mounted() {
    this.tempLineHeight = this.lineHeightVal
    this.tempLineHeightType = this.lineHeightTypeVal
    this.styleList = this.styleList.map(item => ({ ...item, isActive: item.value === this.fontStyleVal }))
    this.textDecorationList = this.textDecorationList.map(item => ({
      ...item,
      isActive: item.value === this.textDecorationVal
    }))
    this.overflowList[0].isActive = this.contentHasLimit && this.contentHasLimitRadio === "行数"
    this.overflowList[1].isActive = this.contentHasLimit && this.contentHasLimitRadio === "字数"
    this.overflowList[2].isActive = !this.contentHasLimit
    this.fontStyleList[0].isActive = parseInt(this.fontWeight) > 500 ? true : false
    this.fontStyleList[1].isActive = this.fontStyle === "normal" ? false : true
    this.fontStyleList[2].isActive = this.textDecoration === "none" ? false : true
    const width = this.$refs.component?.clientWidth || 0
    this.sliderWidth = parseInt((width - 6) / 5)
    this.fontSizeVal = this.originFontSizeVal
    this.$watch(
      () => {
        return "" + this.originFontSizeVal + this.fontWeightVal + this.lineHeightVal + this.lineHeightTypeVal
      },
      val => {
        this.checkFontType()
      },
      {
        immediate: true
      }
    )
  },
  watch: {
    fontWeightVal(val) {
      this.fontStyleList[0].isActive = parseInt(val) > 500 ? true : false
      // this.checkFontType()
    },
    originFontSizeVal(val) {
      // this.checkFontType()
    },
    fontStyleVal(val) {
      this.fontStyleList[1].isActive = val === "normal" ? false : true
    },
    textDecorationVal(val) {
      this.fontStyleList[2].isActive = val === "none" ? false : true
    }
  },
  computed: {
    isBigScreen() {
      return this.request_prefix === "bigScreen"
    },
    overflowModeValue: {
      get() {
        if (this.contentHasLimit) return this.contentHasLimitRadio || "行数"
        return "无"
      },
      set(value, flag) {
        if (flag) return
        if (value === "无") {
          this.$emit("update:contentHasLimit", false)
        } else {
          this.$emit("update:contentHasLimit", true)
          this.$emit("update:contentHasLimitRadio", value)
        }
        this.overflowList = this.overflowList.map((item, index) => {
          return {
            ...item,
            isActive: value === item.value
          }
        })
      }
    },
    disableTextDecoration() {
      return this.colorArrVal?.type === "linearGradient" && !this.isThemeColorVal
    },
    arrangementList() {
      return [
        {
          label: this.writingModeVal === "horizontal-tb" ? "左对齐" : "顶对齐",
          className: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-leftt1" : "icon-portal-text-top-v",
          icon: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-leftt1" : "icon-portal-text-top-v",
          value: "left"
        },
        {
          label: "居中对齐",
          className: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-center1" : "icon-portal-text-center-v",
          icon: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-center1" : "icon-portal-text-center-v",
          value: "center"
        },
        {
          label: this.writingModeVal === "horizontal-tb" ? "右对齐" : "底对齐",
          className: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-right1" : "icon-portal-text-bottom-v",
          icon: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-right1" : "icon-portal-text-bottom-v",
          value: "right"
        },
        {
          label: "两端对齐",
          className: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-both1" : "icon-portal-text-both-v",
          icon: this.writingModeVal === "horizontal-tb" ? "icon-portal-text-both1" : "icon-portal-text-both-v",
          value: "justify",
          type: "highLevel"
        }
      ]
    },
    realOverflowList() {
      return this.overflowList.filter(item => this.overflowTypes.includes(item.value))
    },
    colorlinearGradientAngle: {
      get() {
        return this.options?.colorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "colorlinearGradientAngle", false)
      }
    },
    colorType: {
      get() {
        return this.options?.colorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.options?.startColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options?.endColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    fontWeightMap() {
      const fontWeightMap = this.fontFamilyList.reduce((total, now) => {
        const { value, fontWeightList } = now
        total[value] = fontWeightList
        return total
      }, {})
      return fontWeightMap
    },
    currentFontWeightList() {
      return this.fontWeightMap[this.fontFamilyVal] || this.fontWeightList
    },
    fontTypeConditions() {
      return Object.entries(this.fontTypeMap).reduce((total, now) => {
        const [key, attrs] = now
        total[`${attrs.fontSize}${attrs.fontWeight}${attrs.lineHeightType}${attrs.lineHeight}`] = key
        return total
      }, {})
    },
    textShadowColor: {
      get() {
        if (this.inMapSet) {
          return this.shadowColor
        }
        return this.checkAndSetPrimaryVal(this.options, "textShadowColor", "textShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        if (this.inMapSet) {
          this.$emit("update:shadowColor", newVal)
        } else {
          this.$changeOptionsEV(newVal, "textShadowColor", false)
        }
      }
    },
    textShadowH: {
      get() {
        if (this.inMapSet) {
          return this.shadowH
        }
        return this.checkAndSetPrimaryVal(this.options, "textShadowH", "textShadowH", 0)
      },
      set(newVal) {
        if (this.inMapSet) {
          this.$emit("update:shadowH", newVal)
        } else {
          this.$changeOptionsEV(newVal, "textShadowH", false)
        }
      }
    },
    textShadowV: {
      get() {
        if (this.inMapSet) {
          return this.shadowV
        }
        return this.checkAndSetPrimaryVal(this.options, "textShadowV", "textShadowV", 0)
      },
      set(newVal) {
        if (this.inMapSet) {
          this.$emit("update:shadowV", newVal)
        } else {
          this.$changeOptionsEV(newVal, "textShadowV", false)
        }
      }
    },
    textShadowBlur: {
      get() {
        if (this.inMapSet) return this.shadowBlur
        return this.checkAndSetPrimaryVal(this.options, "textShadowBlur", "textShadowBlur", 0)
      },
      set(newVal) {
        if (this.inMapSet) {
          this.$emit("update:shadowBlur", newVal)
        } else {
          this.$changeOptionsEV(newVal, "textShadowBlur", false)
        }
      }
    },
    textHoverShowAllContent: {
      get() {
        return this.hoverShowAllContent
      },
      set(val) {
        this.$emit("update:hoverShowAllContent", val)
      }
    },
    verticalAlignVal: {
      get() {
        return this.verticalAlign
      },
      set(val) {
        this.updateLatestStyle()
        this.$emit("update:verticalAlign", val)
      }
    },
    showVerticalAlign() {
      return this.writingModeVal === "vertical-lr" && this.enableVerticalAlign
    },
    wordOmitTypeVal: {
      get() {
        return this.wordOmitType
      },
      set(val) {
        this.$emit("update:wordOmitType", val)
      }
    },
    textLimitWordsVal: {
      get() {
        return this.textLimitWords
      },
      set(val) {
        this.$emit("update:textLimitWords", val)
      }
    },
    textLimitLinesVal: {
      get() {
        return this.textLimitLines
      },
      set(val) {
        this.$emit("update:textLimitLines", val)
      }
    },
    isThemeColorVal: {
      get() {
        return this.isThemeColor
      },
      set(val) {
        this.$emit("update:isThemeColor", val)
      }
    },
    colorArrVal: {
      get() {
        return this.colorArr
      },
      set(val) {
        if (val.type === "linearGradient") {
          this.textDecorationVal = "none"
        }
        this.$emit("update:colorArr", val)
      }
    },
    activeNameColorVal: {
      get() {
        return this.activeNameColor
      },
      set(val) {
        this.$emit("update:activeNameColor", val)
      }
    },
    fontWeightVal: {
      get() {
        return this.fontWeight
      },
      set(val) {
        console.log("val :>>", val)

        this.$emit("update:fontWeight", val)
        this.$emit("change", { type: "fontWeight", value: val })
        this.updateLatestStyle()
      }
    },
    originFontSizeVal: {
      get() {
        return this.fontSize
      },
      set(val) {
        this.$emit("update:fontSize", val)
        this.$emit("change", { type: "fontSize", value: val })
        this.updateLatestStyle()
      }
    },
    fontFamilyVal: {
      get() {
        return this.fontFamily
      },
      set(val) {
        historyCombineWrap(() => {
          this.$emit("update:fontFamily", val)
          this.$emit("change", { type: "fontFamily", value: val })
          this.updateLatestStyle()
          const currentWeightList = this.fontWeightMap[val]
          if (currentWeightList?.length && !currentWeightList.some(item => item.value === this.fontWeightVal)) {
            this.fontWeightVal = currentWeightList[0].value
          }
        })()
      }
    },
    fontStyleVal: {
      get() {
        return this.fontStyle || "normal"
      },
      set(val) {
        this.$emit("update:fontStyle", val)
        this.$emit("change", { type: "fontStyle", value: val })
        this.updateLatestStyle()
      }
    },
    textDecorationVal: {
      get() {
        return this.textDecoration || "none"
      },
      set(val) {
        this.$emit("update:textDecoration", val)
        this.$emit("change", { type: "textDecoration", value: val })
        this.updateLatestStyle()
      }
    },
    showLineHeightVal:{
      get(){
        if(this.lineHeightTypeVal === 'normal'){
           return  '自动'
        }
        return this.lineHeightVal
      },
      set(newVal){
        this.lineHeightVal = newVal
      }
    },
    lineHeightVal: {
      get() {
        return this.lineHeight
      },
      set(val) {
        this.tempLineHeight = val
        if (this.inMapSet) {
          this.$emit("updateAttrs", {
            lineHeight: val,
            lineHeightType: this.tempLineHeightType
          })
        } else {
          this.$emit("update:lineHeight", val)
          this.$emit("change", { type: "lineHeight", value: val })
          this.updateLatestStyle()
        }
      }
    },
    letterSpacingVal: {
      get() {
        return this.letterSpacing
      },
      set(val) {
        this.$emit("update:letterSpacing", val)
        this.$emit("change", { type: "letterSpacing", value: val })
        this.updateLatestStyle()
      }
    },
    writingModeVal: {
      get() {
        return this.writingMode
      },
      set(val) {
        this.$emit("update:writingMode", val)
        this.$emit("change", { type: "writingMode", value: val })
      }
    },
    textAlignVal: {
      get() {
        return this.textAlign
      },
      set(val) {
        this.$emit("update:textAlign", val)
        this.$emit("change", { type: "textAlign", value: val })
        this.updateLatestStyle()
      }
    },
    activeArrangement() {
      let index = this.arrangementList.findIndex(item => item.value === this.textAlign)
      // 44.4 一个滑块的宽度
      this.translate = this.sliderWidth * index
      return this.textAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingModeVal = val
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    lineHeightTypeVal: {
      get() {
        return this.lineHeightType || "px"
      },
      set(val) {
        this.tempLineHeightType = val
        this.$emit("update:lineHeightType", val)
        this.updateLatestStyle()
      }
    },
    letterSpacingTypeVal: {
      get() {
        return this.letterSpacingType || "px"
      },
      set(val) {
        this.$emit("update:letterSpacingType", val)
      }
    }
  },
  methods: {
    lineHeightOperate(type) {
      const operateValue = this.lineHeightTypeVal === "%" ? 10 : 1
      const nextValue = this.lineHeightVal + (type === "add" ? 1 : -1) * operateValue
      this.lineHeightVal = nextValue < 0 ? 0 : nextValue
    },
    updateLatestStyle() {
      if (this.options.innerElement !== "cxText") return
      this.$nextTick(() => {
        this.$reuseMap.addReuseMap("cxText", {
          fontSize: this.options.fontSize,
          fontStyle: this.options.fontStyle,
          fontWeight: this.options.fontWeight,
          textDecoration: this.options.textDecoration,
          letterSpacing: this.options.letterSpacing,
          fontFamily: this.options.fontFamily,
          textAlign: this.options.textAlign,
          lineHeight: this.options.lineHeight,
          lineHeightType: this.options.lineHeightType,
          width: this.options.width,
          height: this.options.height,
          verticalAlign: this.options.verticalAlign
        })
      })
    },
    changeFontWeight() {
      this.fontWeightVal = this.fontWeightVal == 600 ? 400 : 600
    },
    changeFontStyle() {
      this.fontStyleVal = this.fontStyleVal == "italic" ? "normal" : "italic"
    },
    changeDecoration(value) {
      if (this.disableTextDecoration) return
      this.textDecorationVal = this.textDecorationVal !== value ? value : "none"
    },
    checkFontType() {
      const condition = `${this.originFontSizeVal}${this.fontWeightVal}${this.lineHeightTypeVal}${this.lineHeightVal}`
      this.activeFontType = this.fontTypeConditions[condition] || ""
    },
    addTextShadow() {
      if (!Array.isArray(this.textShadowH) || !Array.isArray(this.textShadowColor)) {
        if (this.inMapSet) {
          this.$emit("updateAttrs", {
            shadowH: [this.textShadowH],
            shadowV: [this.textShadowV],
            shadowBlur: [this.textShadowBlur],
            shadowColor: [this.textShadowColor]
          })
        } else {
          this.textShadowH = [this.textShadowH]
          this.textShadowV = [this.textShadowV]
          this.textShadowBlur = [this.textShadowBlur]
          this.textShadowColor = [this.textShadowColor]
        }
        return
      }
      let textShadowH = JSON.parse(JSON.stringify(this.textShadowH))
      let textShadowV = JSON.parse(JSON.stringify(this.textShadowV))
      let textShadowBlur = JSON.parse(JSON.stringify(this.textShadowBlur))
      let textShadowColor = JSON.parse(JSON.stringify(this.textShadowColor))
      textShadowH.push(0)
      textShadowV.push(4)
      textShadowBlur.push(4)
      textShadowColor.push("rgba(0,0,0,0.25)")
      if (this.inMapSet) {
        this.$emit("updateAttrs", {
          shadowH: textShadowH,
          shadowV: textShadowV,
          shadowBlur: textShadowBlur,
          shadowColor: textShadowColor
        })
      } else {
        this.textShadowH = textShadowH
        this.textShadowV = textShadowV
        this.textShadowBlur = textShadowBlur
        this.textShadowColor = textShadowColor
      }
    },
    changeFontType(value, flag, i) {
      if (flag) return
      this.activeFontType = value
      const fontTypeStyle = this.fontTypeMap[value]
      if (fontTypeStyle) {
        if (this.inMapSet) {
          // 如果是在属性映射组件中，单独处理
          this.$emit("updateAttrs", {
            fontSize: fontTypeStyle.fontSize,
            fontWeight: fontTypeStyle.fontWeight,
            lineHeight: fontTypeStyle.lineHeight,
            lineHeightType: fontTypeStyle.lineHeightType
          })
        } else {
          fontTypeStyle.fontSize && (this.originFontSizeVal = fontTypeStyle.fontSize)
          fontTypeStyle.fontWeight && (this.fontWeightVal = fontTypeStyle.fontWeight)
          fontTypeStyle.lineHeight && (this.lineHeightVal = fontTypeStyle.lineHeight)
          fontTypeStyle.lineHeightType && (this.lineHeightTypeVal = fontTypeStyle.lineHeightType)
        }
      }
    },
    changeStyle(flag, temp, hoverFlag) {
      let curFontStyleList = hoverFlag ? "hoverFontStyleList" : "fontStyleList"
      switch (flag) {
        case 0:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.fontWeightVal = 400
          } else {
            this[curFontStyleList][flag].isActive = true
            this.fontWeightVal = 600
          }
          break
        case 1:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.fontStyleVal = "normal"
          } else {
            this[curFontStyleList][flag].isActive = true
            this.fontStyleVal = "italic"
          }
          break
        case 2:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.textDecorationVal = "none"
          } else {
            this[curFontStyleList][flag].isActive = true
            this.textDecorationVal = "underline"
          }
          break
      }
    },
    changeWritingMode(value) {
      if (this.writingModeVal === value) return
      this.$emit("update:writingMode", value)
    },
    changeOverflow(value, flag, i) {
      if (flag) return
      if (value === "无") {
        this.$emit("update:contentHasLimit", false)
      } else {
        this.$emit("update:contentHasLimit", true)
        this.$emit("update:contentHasLimitRadio", value)
      }
      this.overflowList = this.overflowList.map((item, index) => {
        return {
          ...item,
          isActive: value === item.value
        }
      })
      this.updateLatestStyle()
    },
    changeArrangement(val, hoverFlag) {
      if (this.hideHighLevelSetting && val.type === "highLevel") {
        return
      }
      this.textAlignVal = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      if (this.hideHighLevelSetting) {
        return
      }
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        this.writingModeVal = "horizontal-tb"
      } else {
        this[curActiveArrangementOrder].isActive = true
        this.writingModeVal = "vertical-lr"
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    lineHeightHandleCommand(val) {
      if (this.lineHeightTypeVal === val) {
        return
      }
      this.lineHeightTypeVal = val
      this.lineHeightVal = val === "%" ? 100 : 34
    },
    letterSpacingHandleCommand(val) {
      if (this.letterSpacingTypeVal === val) {
        return
      }
      this.letterSpacingTypeVal = val
      this.letterSpacingVal = val === "%" ? 1 : 0
    }
  }
})
</script>
<style lang="scss" scoped>
.set-container {
  .set-item {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 8px;
    .title {
      width: 56px;
      margin-right: 12px;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      flex-shrink: 0;
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.checkbox_colorPicker_container {
  height: 32px;
}
.font-flex-content {
  display: flex;
  gap: 8px;
  .font-arrangement-btn {
    flex: 1;
    gap: 3px;
    span.divide:not(.select)::after {
      display: block !important;
    }
  }
}
.more-setting {
  display: flex;
  height: 24px;
  user-select: none;
  cursor: pointer;
  margin-bottom: 8px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  background: var(--inputBackGround);
  color: var(--subTextColor);
  border-radius: 4px;
  gap: 4px;
  &:last-child {
    margin-bottom: 0;
  }
  .icon {
    color: var(--thirdTextColor);
  }
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  flex: 1;
  .num-btn {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
.text-shadow-container {
  margin-bottom: 8px;
}
.bigScreen .font-arrangement-btn.multiple span.select {
  background: #575c66;
}
.font-arrangement-btn span.no-divide:nth-child(2)::after {
  display: none;
}
::v-deep .font-family-select .el-input__inner {
  font-family: var(--fontFamily);
}
</style>
<style lang="scss">
.lineheight-dropdown .el-dropdown-menu__item {
  width: 82px;
  padding: 0 12px;
  line-height: 37px;
  .selected-icon {
    display: inline-block;
    width: 16px;
    font-size: 16px;
    margin-right: 8px;
  }
}
.font-families .el-select-dropdown__item {
  padding: 0;
  overflow: hidden;
}
.font-family-img {
  display: inline-block;
  width: 174px;
  height: 38px;
  width: auto;
}
.el-select-dropdown.font-families {
  transform: translate(-10px, 0);
}
</style>
<style scoped>
.ml12 {
  margin-left: 12px;
}
.font-arrangement-btn {
  height: 32px;
}
.font-arrangement-btn span {
  height: 26px;
}
.setting-item-txt {
  color: var(--collapsibleItemContentTextColor);
}
.set-item-28/deep/ .el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 4px 0 4px 12px;
}
.set-item-28/deep/ .el-select .el-input__suffix-inner {
  line-height: 28px;
}
.set-item-28/deep/ .number-input-box .suffix_text {
  line-height: 28px;
}

.set-item-28/deep/ .el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}
.set-item-28/deep/ .suffix_text {
  line-height: 28px;
}
.set-item-28/deep/ .el-input-group__append .icon-arrows-bg {
  height: 13px;
}
.font-arrangement-btn span:hover::before {
  color: var(--collapsibleItemContentTextColor);
}
.cx_style/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
.el-input__inner:active {
  border: 1px solid var(--themeColor) !important;
}
.font-arrangement-btn span {
  width: calc(100% / 5);
}
.font-arrangement-btn span.text {
  font-size: 13px;
  line-height: 26px;
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 5);
}
.font-arrangement-btn.multiple span.select {
  background: var(--leftMenuBgColor);
}
.multiple span:first-child::after {
  display: none;
}
.multiple span:nth-child(2)::after {
  display: block;
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -28px !important;
}
.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
  display: inline-block;
  vertical-align: top;
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
::v-deep .el-tooltip.disabled {
  cursor: not-allowed;
}
</style>
